/**
 * CLI-051: Hiring-company onboarding copy and required compliance document types.
 * Agreement text is shown in-app (scroll + consent); replace with legal-approved copy before production.
 */

export const CLIENT_ENGAGEMENT_CONSENT_VERSION = '2026-03-21';

/** Shown in a scrollable panel during /clients/new — consultancy-facing acknowledgment, not a substitute for executed contracts. */
export const CLIENT_ENGAGEMENT_AGREEMENT_TEXT = `CLIENT ENGAGEMENT — PLATFORM DISCLAIMER & CONSENT (CONSULTANCY USER)

By proceeding, you confirm that you are authorised to create this Client (hiring company) record on behalf of your organisation.

1. Commercial relationship
   Executed agreements (MSA, SOW, rate cards, statements of work) between your consultancy and the hiring company remain the legal source of truth. This screen does not replace signatures or counsel review.

2. Data & confidentiality
   You will only enter and upload information you are permitted to process. You are responsible for informing the client of how their data is used in line with your privacy notices and applicable law.

3. Document verification
   Your organisation may require specific documents before recruitment work begins. Uploaded files will be reviewed internally. Until required items are approved, the product may block opening new requisitions or jobs for this client.

4. Accuracy
   Information you provide should be accurate. You may update the client record as the relationship evolves.

If you do not agree, do not check the consent box or create the client.

— GoGrabJob B2B (template; replace with your legal-approved text)`;

export const REQUIRED_CLIENT_COMPLIANCE_DOC_TYPES = [
  { slug: 'executed_msa_sow', label: 'Executed MSA / SOW (signed PDF)' },
  { slug: 'company_registration', label: 'Company registration / COI' },
  { slug: 'tax_compliance', label: 'Tax ID / GST (or equivalent)' },
] as const;

export type RequiredClientComplianceDocSlug = (typeof REQUIRED_CLIENT_COMPLIANCE_DOC_TYPES)[number]['slug'];

/** §9.7 — `/clients/new` wizard step labels (6 UI steps). */
export const CLIENT_ONBOARDING_WIZARD_STEP_LABELS = [
  'Company',
  'Contact',
  'Engagement',
  'Commercial',
  'Documents',
  'Review',
] as const;

/** Optional footer links on engagement step (replace with tenant-specific URLs if needed). */
export const CLIENT_ONBOARDING_EXTERNAL_LINKS = {
  terms: 'https://gograbjob.com/terms',
  privacy: 'https://gograbjob.com/privacy',
} as const;
